"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

/**
 * TestResponse service.
 * @module ChiRhos/api/TestResponseApi
 * @version v1
 */
var TestResponseApi =
/*#__PURE__*/
function () {
  /**
   * Constructs a new TestResponseApi.
   * @alias module:ChiRhos/api/TestResponseApi
   * @class
   * @param {module:ChiRhos/ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ChiRhos/ApiClient#instance} if unspecified.
   */
  function TestResponseApi(apiClient) {
    (0, _classCallCheck2["default"])(this, TestResponseApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
   */


  (0, _createClass2["default"])(TestResponseApi, [{
    key: "_failureWithHttpInfo",
    value: function _failureWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/TestResponse/Failure', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "Failure",
    value: function Failure() {
      return this._failureWithHttpInfo().then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.verify  (default to false)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_successWithHttpInfo",
    value: function _successWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        verify: opts['verify']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/TestResponse/Success', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.verify  (default to false)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "Success",
    value: function Success(opts) {
      return this._successWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
  }]);
  return TestResponseApi;
}();

exports["default"] = TestResponseApi;
module.exports = exports.default;